const updateSelect = (wrapper:HTMLElement) => {
  if (wrapper) {
    let list = wrapper.querySelector('.js-customSelect-content');
    if (list) {
      if (list.scrollTop === 0) {
        wrapper.classList.remove('upper');
      } else {
        wrapper.classList.add('upper');
      }
  
      if (list.scrollTop + list.clientHeight >= list.scrollHeight) {
        wrapper.classList.remove('bottom');
      } else {
        wrapper.classList.add('bottom');
      }
    }
  }
};

export default updateSelect;